function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M224.8,99.8l15.6-31.2l31.2-15.6l-31.2-15.6L224.8,6l-15.6,31.2l-31.2,15.6l31.2,15.6L224.8,99.8z M84.1,162.3 l26-52.1l52.1-26l-52.1-26L84.1,6l-26,52.1L6,84.1l52.1,26L84.1,162.3z M84.1,68.5c8.6,0,15.6,7,15.6,15.6s-7,15.6-15.6,15.6 s-15.6-7-15.6-15.6S75.5,68.5,84.1,68.5z M427.9,287.2l-26,52.1l-52.1,26l52.1,26l26,52.1l26-52.1l52.1-26l-52.1-26L427.9,287.2z  M427.9,381c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6S436.5,381,427.9,381z M496.8,82.1l-67-67 C423.8,9,415.8,6,407.8,6c-8,0-16,3-22.1,9.2L15.2,385.7c-12.2,12.2-12.2,32,0,44.2l67,67c6.1,6.1,14.1,9.2,22.1,9.2s16-3,22.1-9.2 l370.5-370.5C509,114.1,509,94.3,496.8,82.1L496.8,82.1z M104.2,474.7l-67-67l252.3-252.3l67,67L104.2,474.7z M378.7,200.3l-67-67 l96.1-96.1h0l67,67L378.7,200.3L378.7,200.3z"
});

var SvgIconConditionOrder = function SvgIconConditionOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconConditionOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_condition_order.320522d1.svg";
export { ForwardRef as ReactComponent };